import { Overlay } from '@angular/cdk/overlay';
import {
    Component,
    DestroyRef,
    OnInit,
    Signal,
    WritableSignal,
    computed,
    effect,
    signal,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MAT_SELECT_SCROLL_STRATEGY } from '@angular/material/select';
import { MatTableDataSource } from '@angular/material/table';
import { CostObject } from 'app/api';
import { DialogBuilderComponent } from 'app/core/dialogBuilder/dialog-builder.component';
import {
    GridViewsModule,
    TableColumnDef,
} from '../../../../../../../projects/grid-views/src/public-api';
import { TableService } from '../table.service';
import { TranslocoService } from '@ngneat/transloco';
import getDisplayedTableColumns from './displayed-table-columns';

@Component({
    selector: 'select-dictionary-table-dialog',
    imports: [GridViewsModule],
    templateUrl: './select-dictionary-table-dialog.component.html',
    styleUrl: './select-dictionary-table-dialog.component.scss',
    providers: [
        {
            provide: MAT_SELECT_SCROLL_STRATEGY,
            useFactory: (overlay: Overlay) => () => overlay.scrollStrategies.reposition(),
            deps: [Overlay],
        },
    ],
})
export class SelectDictionaryTableDialogComponent
    extends DialogBuilderComponent<any>
    implements OnInit
{
    _translocoContent = signal(null);

    data: WritableSignal<any> = signal([]);
    displayedColumns: Signal<Array<TableColumnDef>> = computed(() =>
        getDisplayedTableColumns(this._translocoContent())
    );
    dataSource: Signal<MatTableDataSource<CostObject>>;
    selection: WritableSignal<any[]> = signal([]);

    constructor(
        private service: TableService,
        private _destroy: DestroyRef,
        private _translocoService: TranslocoService
    ) {
        super();
        this._translocoService.selectTranslation('bpTask').subscribe(content => {
            this._translocoContent.set(content);
        });

        this.service
            .getTables()
            .pipe(takeUntilDestroyed(this._destroy))
            .subscribe(res => {
                this.data.set(res);
            });

        this.dataSource = computed(() => {
            return new MatTableDataSource(this.data()) ?? new MatTableDataSource([]);
        });

        effect(() => {
            const code = this.executeActionSignal();

            if (code === 'selectTable') {
                this.service.selectedTable.set(this.selection()[0]);
                this.closeDialog();
            }
        });
    }

    override ngOnInit(): void {
        super.ngOnInit();
        setTimeout(() => {
            this.selection.set(this.componentData.selection);
        });
    }

    onRowSelected($event: any): void {
        if (!$event[0]) {
            return;
        }
        this.selection.set($event);
    }
}
